export const permissionsEndpoints = {
  getAllModules: "/user-management/modules",
  getModuleByCode: "/user-management/permissions",
  getAccessCatalog: "/access/catalog",
  getAllRoles: "/user-management/roles",
  createRole: "/user-management/roles",
  editRole: "/user-management/roles",
  getRoleById: "/user-management/roles",
  getRoleHolders: (roleId: string) => `/user-management/roles/${roleId}/holders`,
  getRoleDeactivateImpact: (roleId: string) => `/user-management/roles/${roleId}/deactivate-impact`,
  getRoleScopeImpact: (roleId: string) => `/user-management/roles/${roleId}/scope-impact`,
  getRoleDepartments: "/user-management/roles/departments",
  activateRole: "/user-management/roles/activate",
  deactivateRole: "/user-management/roles/deactivate",
  getRolesDropdown: "/user-management/dropdown",
  dropdown: "/dropdown",
};
